import styled from 'styled-components';
import ProductionCompaniesContainer from './ProductionCompanies/ProductionCompaniesContainer'
import DepartmentsContainer from './DepartmentsContainer/DepartmentsContainer'

const StaffSheet = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  h1 {
    font-size: 18pt;
  }

  h2 {
    font-size: 10pt;
    margin: 0;
  }

  p, table {
    font-size: 8pt;
  }
`

const ContentContainer = styled.div`
  width: 90%;
`;

const ImgContainer = styled.div`
  width: 15%;
  margin: auto;
  > img {
    width 100%;
  }
`;


const TitleContainer = styled.div`
  max-width: 65%;
  margin: auto;
`

const StaffSheetLayout = ({data}) => {
return (
    typeof data === "undefined" ? null :
    <StaffSheet>
      <ContentContainer>
      {data.uploadedImage &&
        <ImgContainer>
          <img src={URL.createObjectURL(data.uploadedImage)} alt=""/>
        </ImgContainer>}
        <TitleContainer>
          <h1>{data.projectName.toUpperCase()}<br/>STAFF LIST</h1>
        </TitleContainer>
        <ProductionCompaniesContainer companies={data.prodCompanies}/>
        <DepartmentsContainer departments={data.departments} />
      </ContentContainer>
    </StaffSheet>
  )
}


export default StaffSheetLayout;
